(function() {
    'use strict';

    angular.module('format')
        .controller('FormatListController', FormatListController);

    FormatListController.$inject = ['$state', 'formatDataSrvc', 'formatSrvc', 'lodashService', 'notificationSrvc', 'formatMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'formatPermissionsConst', 'filterQuerySrvc'];

    function FormatListController($state, formatDataSrvc, formatSrvc, lodashService, notificationSrvc, formatMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, formatPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.formatRows = [];
        self.formatCols = [{
            title: 'Obraz makiety',
            value: 'image_url',
            type: 'image',
            onClick: openImg,
            searchable: false,
            orderable: false
        }, {
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Rozmiar X',
            value: 'size_x',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Rozmiar Y',
            value: 'size_y',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Grupa',
            value: 'format_group',
            type: 'text',
            orderValue: 'format_group__name',
            searchable: true,
            orderable: true
        }];
        self.modelPermissions = formatPermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.searchQuery = {
            pk: null,
            size_x: null,
            size_y: null,
            format_group: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.isAll = isAll;
        self.filterAll = filterAll;
        self.isWithGroup = isWithGroup;
        self.filterWithGroup = filterWithGroup;
        self.isWithoutGroup = isWithoutGroup;
        self.filterWithoutGroup = filterWithoutGroup;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getFormats();
        }

        function getFormats(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    with_group: $state.params.with_group,
                    pk: self.searchQuery.pk,
                    size_x: self.searchQuery.size_x,
                    size_y: self.searchQuery.size_y,
                    format_group: self.searchQuery.format_group,
                    ordering: self.searchQuery.ordering
                };
            }
            return formatDataSrvc.list(
                filterObj
            ).$promise.then(
                function(response) {
                    self.formatRows = response.results;
                    self.pageOpts.count = response.count;
                    return response;
                },
                function(response) {
                    if (response.status === 404 && filterObj.page !== 1) {
                        checkSearchSrvc.recall(filterObj, getFormats);
                    }
                }
            ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.format.create');
        }

        function onEdit(row) {
            $state.go('layout.format.update', { pk: row.pk });
        }

        function onDelete(row) {
            return formatSrvc.remove(row, function(response) {
                notificationSrvc.notification("success", formatMessagesConst.delete);
                lodashService.remove(self.formatRows, { pk: row.pk });
                return response;
            });
        }

        function isAll() {
            return $state.params.with_group === undefined;
        }

        function filterAll() {
            $state.go('layout.format.list', { with_group: undefined });
        }

        function isWithGroup() {
            return $state.params.with_group === '1';
        }

        function filterWithGroup() {
            $state.go('layout.format.list', { with_group: '1' });
        }

        function isWithoutGroup() {
            return $state.params.with_group === '0';
        }

        function filterWithoutGroup() {
            $state.go('layout.format.list', { with_group: '0' });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getFormats();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getFormats();
        }

        function openImg(format){
            if (format.image_url){
                window.open(format.image_url, '_blank');
            }
        }
    }
})();
